import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.5 10.75h-3c-1.409 0-2.25-.841-2.25-2.25v-3c0-1.409.841-2.25 2.25-2.25h3c1.409 0 2.25.841 2.25 2.25v3c0 1.409-.841 2.25-2.25 2.25m-3-6c-.589 0-.75.161-.75.75v3c0 .589.161.75.75.75h3c.589 0 .75-.161.75-.75v-3c0-.589-.161-.75-.75-.75zm-7 6h-3c-1.409 0-2.25-.841-2.25-2.25v-3c0-1.409.841-2.25 2.25-2.25h3c1.409 0 2.25.841 2.25 2.25v3c0 1.409-.841 2.25-2.25 2.25m-3-6c-.589 0-.75.161-.75.75v3c0 .589.161.75.75.75h3c.589 0 .75-.161.75-.75v-3c0-.589-.161-.75-.75-.75zm13 16h-3c-1.409 0-2.25-.841-2.25-2.25v-3c0-1.409.841-2.25 2.25-2.25h3c1.409 0 2.25.841 2.25 2.25v3c0 1.409-.841 2.25-2.25 2.25m-3-6c-.589 0-.75.161-.75.75v3c0 .589.161.75.75.75h3c.589 0 .75-.161.75-.75v-3c0-.589-.161-.75-.75-.75zm-7 6h-3c-1.409 0-2.25-.841-2.25-2.25v-3c0-1.409.841-2.25 2.25-2.25h3c1.409 0 2.25.841 2.25 2.25v3c0 1.409-.841 2.25-2.25 2.25m-3-6c-.589 0-.75.161-.75.75v3c0 .589.161.75.75.75h3c.589 0 .75-.161.75-.75v-3c0-.589-.161-.75-.75-.75z"
    }, null, -1)
  ])))
}
export default { render: render }